import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { setAuthenticatedUser, updateNestedUserField, updateUser } from './authenticated-user.store';

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(setAuthenticatedUser, updateUser, updateNestedUserField),
  effect: (action, listenerApi) => {
    localStorage.setItem('user', JSON.stringify(listenerApi.getState().authenticatedUser));
  },
});